<template>
  <div class="bg-gray-800 pb-1 rounded-t-none rounded-lg">
    <ul class="text-sm select-none focus:outline-none" sortable>
      <li
        class="flex items-center justify-between p-3 focus:outline-none"
        :class="[!selectedLabels.length ? 'bg-white' : 'bg-gray-800']"
        @click="handleDeselectAll"
      >
        <div class="w-full flex items-center cursor-pointer">
          <div
            class="flex items-center justify-center text-gray-600 w-6 h-6 rounded-full bg-gray-200 text-gray-600 border border-gray-600"
          >
            All
          </div>
          <div class="pl-2" :class="[!selectedLabels.length ? 'text-gray-800' : 'text-white']">
            Toutes les contributions
          </div>
        </div>
      </li>
      <li class="flex items-center justify-between p-3 focus:outline-none bg-gray-700" @click="handleToggleSelectAll">
        <div class="w-full flex items-center cursor-pointer">
          <img class="w-6 h-6 cursor-pointer" src="../../assets/icons/allLabels.svg" alt="Déplacer" />
          <div class="pl-2">
            Toutes les catégories
          </div>
        </div>
      </li>
      <li
        v-for="(label, index) in labels"
        :key="label.guid_text"
        :id="index"
        class="flex items-center justify-between p-3 focus:outline-none"
        :class="[
          selectedLabels.includes(label.guid_text)
            ? index % 2
              ? 'bg-gray-300'
              : 'bg-white'
            : index % 2
            ? 'bg-gray-700'
            : 'bg-gray-800',
        ]"
        style="width:256px"
        @click="handleToggleSelected(label.guid_text)"
        sortItem
      >
        <div class="w-full flex items-center cursor-pointer">
          <div
            class="flex items-center justify-center text-gray-600 w-6 h-6 rounded-full"
            :style="'background-color:' + getColors(label.color).bg + '; color:' + getColors(label.color).font"
          >
            {{ label.initials }}
          </div>
          <div class="pl-2" :class="[selectedLabels.includes(label.guid_text) ? 'text-gray-800' : 'text-white']">
            {{ label.text }}
          </div>
        </div>
        <div class="flex items-center">
          <img class="w-4 h-4 cursor-pointer" src="../../assets/icons/hamburger.svg" alt="Déplacer" />
        </div>
      </li>
      <li v-if="errorMaxItems" class="text-center font-light bg-red-500 text-white w-full py-3 focus:outline-none">
        {{ realItemsPerLine - 1 }} labels max
      </li>
    </ul>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions, mapGetters } from "vuex"
import { Sortable } from "@shopify/draggable/lib/es5/draggable.bundle.legacy"

export default {
  props: {
    edited: Boolean,
    realItemsPerLine: Number,
  },
  data() {
    return {
      sortable: null,
      isInEditMode: false,
      errorMaxItems: false,
    }
  },
  computed: {
    ...mapGetters("labels", ["getColors"]),
    ...mapState({
      labels: (state) => state.labels.all,
      selectedLabels: (state) => state.labels.selected,
      gridMode: (state) => state.grid.gridMode,
    }),
  },
  watch: {
    edited() {
      if (this.edited === true) {
        this.$emit("closeMenu")
      }
    },
    realItemsPerLine() {
      this.errorMaxItems = false
    },
  },
  methods: {
    ...mapActions("labels", ["setLabelsOrder"]),
    ...mapMutations("labels", ["toggleSelected", "toggleSelectAll", "deselectAll"]),
    ...mapMutations("grid", ["setGridMode"]),
    handleDeselectAll() {
      this.deselectAll()
      if (this.gridMode === "label") {
        this.setGridMode("grid")
      }
      this.$emit("closeMenu")
    },
    handleToggleSelectAll() {
      if (this.labels.length > this.realItemsPerLine - 1) {
        this.errorMaxItems = true
        return
      }
      this.toggleSelectAll()
      this.$emit("closeMenu")
    },
    handleToggleSelected(guid) {
      if (this.selectedLabels.length === this.realItemsPerLine - 1 && !this.selectedLabels.includes(guid)) {
        this.errorMaxItems = true
        return
      }
      this.errorMaxItems = false
      this.toggleSelected(guid)
      this.$emit("isInEditMode")
    },
    createSortable() {
      this.sortable = new Sortable(document.querySelector("[sortable]"), {
        draggable: "[sortItem]",
        delay: 200,
      })

      this.sortable.on("sortable:stop", () => {
        let htmlLabels = this.sortable.getDraggableElementsForContainer(document.querySelector("[sortable]"))
        this.setLabelsOrder(htmlLabels)
      })
    },
  },
  mounted() {
    this.createSortable()
  },
}
</script>

<style></style>
